<template>
  <custom-dialog width="445px" :showClose="false" title="退费" v-if="visibleObj.refundDialog"
    :visible="visibleObj.refundDialog" @close="dialogVisible('refundDialog')" @save="comfirm">
    <div class="content" slot="content" v-loading="loading" :element-loading-text="loadingText">
      <div class="content-price"><span class="price-icon">¥</span>{{ dialogObj.finalPrice }}</div>
      <div class="color6671 size14">请选择退费方式：</div>
      <el-radio-group v-model="refundType" class="mt14">
        <el-radio v-for="item in typeDict" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
      </el-radio-group>
      <div class="color1F23 mt18 size14">{{ payObj.payWaystr }}：¥{{ dialogObj.finalPrice }}</div>
      <el-input class="mt16" v-model="refundForm.remark" placeholder="请填写退费原因"></el-input>
      <div class="mt20 textRight">
        <custom-button type="info" size="medium" @click="dialogVisible('refundDialog')">取消</custom-button>
        <custom-button type="primary" size="medium" @click="comfirm">确定</custom-button>
      </div>
    </div>
    <div slot="footer"></div>
  </custom-dialog>
</template>

<script>
import CustomDialog from '@/components/customDialog/CustomDialog'
import { getPayRecord } from '@/api/pricingDetails'
import { isEmptyArray, dictText, debounce, isNull, isNullObj, timeoutTimer } from '@/utils/validateBase'
import { payDTO, CommonDTO } from '@/DTO/index'
import { cancelSettlement } from '@/utils/yibaoTools'
export default {
  // 定义引入的组件
  components: { CustomDialog },
  props: {
    visibleObj: {
      type: Object,
      default: {}
    },
    dialogObj: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      PAY_WAY: [],
      typeLable: '',
      refundType: 1,
      input: '',
      typeDict: [
        { value: 1, label: '原路退还' },
        { value: 2, label: '直接退现金' },
      ],
      payObj: {},//支付对象
      refundForm: {
        remark: ''
      },//退款对象
      refundTaskId: '',//退款单id
      loading: true,
      loadingText: '请稍后'
    }
  },
  //变量监听
  watch: {
    refundType: {
      handler() {
        if (this.refundType == 1) {
          this.payObj.payWaystr = dictText(this.payObj.payWay, this.PAY_WAY)
        } else {
          this.payObj.payWaystr = '现金'
        }
      }
    }
  },
  // 页面初始化
  async created() {
    this.PAY_WAY = await CommonDTO.getPayWay()
    this.refundForm = {
      deptId: this.$session.get('deptId'),
      refundAmount: this.dialogObj.finalPrice, registeredId: this.dialogObj.registeredId, remark: null, type: this.dialogObj.type, channel: this.dialogObj.channel
    }
    this.getPayRecord();
  },
  // 页面DOM加载完成
  mounted() { },
  //离开页面时执行
  destroyed() {
    clearInterval(this.intervalId)
    clearTimeout(this.timeoutId)
  },
  // 页面方法
  methods: {
    /**
     * 创建退款单
     */
    async createRefundTask() {
      this.loading = true;
      let obj = {
        orderId: this.dialogObj.registeredId,
        orderType: 0,
        amount: this.dialogObj.finalPrice,
      }
      let { code, data } = await payDTO.createRefundTask(obj)
      if (code == 200) {
        this.refundTaskId = data.id
        this.editRefundTaskDetail()
      } else {
        this.loading = false;
      }
    },
    /**
     * 编辑退款明细
     */
    async editRefundTaskDetail() {
      let obj = {
        refundTaskId: this.refundTaskId,
        refundReason: this.refundForm.remark,
        taskDetails: [
          { orderPayNumber: this.refundForm.orderPayNumber, refundWay: this.refundForm.refundWay, amount: this.refundForm.refundAmount }
        ]
      }
      let { code, data } = await payDTO.editRefundTaskDetail(obj)
      if (code == 200) {
        let dataObj = data[0]
        let preParams = { deptId: this.$session.get('deptId'), refundTaskDetailId: dataObj.id }
        this.handleRefund(preParams)
      } else {
        this.loading = false;
      }
    },

    /**
    * 查询消息
    */
    getConsumeMessage(id) {
      this.handleConsumeMessage(id)
      timeoutTimer('timeoutId2', () => {
        this.closeInterval()
      }, 5 * 60 * 1000);
    },
    /**
    * 执行查询消息
    */
    handleConsumeMessage(id) {
      CommonDTO.consumeMessage({ id }).then(res => {
        if (res.code == 200) {
          let list = isNull(res.data) ? [] : res.data
          let defeatedObj = list.find(item => { return item.type == 1 && item.status == '2' }) //失敗消息
          let isEnd = list.some(item => { return item.type == -1 })
          if (!isNullObj(defeatedObj)) {
            this.$message.error('退款失败，请在退款管理中重新退款！')
            this.closeInterval()
            return;
          }
          if (isEnd) {
            this.$message.success("操作成功，请在退款管理中查看退款进度。");
            this.closeInterval()
            return
          }
          timeoutTimer('timeoutId1', () => {
            this.handleConsumeMessage(id)
          }, 1000)
        } else {
          this.closeInterval()
        }
      }).catch(err => {
        this.$message.error('退款超时')
        this.closeInterval()

      })
    },
    /**
     * 关闭定时器并刷新
     */
    closeInterval() {
      clearTimeout(this.timeoutId1)
      clearTimeout(this.timeoutId2)
      this.dialogVisible('refundDialog')
      this.dialogVisible('registerDetailDialog')
      this.$emit('refresh')
      this.loadingText = '请稍后'
      this.loading = false;
    },
    /**
     * 执行退款
     */
    handleRefund(preParams) {
      this.loadingText = '退款中，请稍后'
      // 好码齐退款
      if (this.refundForm.refundWay == '1') {
        let params = {
          refundReason: this.refundForm.remark,
          attach: isNull(this.payObj.paymentRecipeYb) ? {} : this.payObj.paymentRecipeYb
        }
        cancelSettlement(preParams, params, this).then(res => {
          this.$message.success("操作成功，请在退款管理中查看退款进度。");
          this.dialogVisible('refundDialog')
          this.dialogVisible('registerDetailDialog')
          this.$emit('refresh')
          this.loading = false;
        })
        // 医保退款
      }else if (this.refundForm.refundWay == '3') {
        payDTO.refundFun(preParams).then(async refundRes => {
          if (refundRes.code == 200) {
            this.getConsumeMessage(refundRes.data.attach.queueId)
          } else {
            this.loading = false;
            this.loadingText = '请稍后'
          }
        }).catch(err => {
          this.loading = false;
          this.loadingText = '请稍后'
        })
      } else {
        // 其他方式退款
        payDTO.refundFun(preParams).then(async refundRes => {
          if (refundRes.code == 200) {
            let time = await CommonDTO.getSystemTimeDTO()
            let obj = {
              refundNumber: refundRes.data.refundNumber,
              refundStatus: '1',
              amount: this.dialogObj.finalPrice,
              refundTime: this.$moment(time).format('YYYY-MM-DD HH:mm:ss'),
              reason: this.refundForm.remark,
              attach: {},
            }
            payDTO.refundCallback(obj).then(res => {
              if (res.code == 200) {
                this.$message.success("操作成功，请在退款管理中查看退款进度。");
                this.dialogVisible('refundDialog')
                this.dialogVisible('registerDetailDialog')
                this.$emit('refresh')
                this.loading = false;
              } else {
                this.loading = false;
              }
            }).catch(err => {
              this.loading = false;
            })
          } else {
            this.loading = false;
          }
        }).catch(err => {
          this.loading = false;
        })
      }

    },

    /**
    * 关闭
    */
    dialogVisible(name) {
      this.$emit("close", name);
    },
    /**
   * 确认
   */
    comfirm: debounce(function () {
      if (this.refundType == '2') {
        this.refundForm.refundWay = 2
      }
      this.createRefundTask()
      // if (this.refundType == 1) {
      //     this.editRefundTaskDetail()
      // } else {

      // }
    }, 1000, true),
    // comfirm() {
    //     if (this.refundType == '2') {
    //         this.refundForm.refundWay = 2
    //     }
    //     this.loading = true;
    //     payDTO.refundFun(this.refundForm, this.refundForm).then(refundRes => {
    //         if (refundRes.code == 200) {
    //             registerRefund(this.refundForm).then(res => {
    //                 if (res.code == 200) {
    //                     this.$message.success("退款退号成功！");
    //                     this.dialogVisible('refundDialog')
    //                     this.dialogVisible('registerDetailDialog')
    //                     this.$emit('refresh')
    //                     this.loading = false;
    //                 }
    //             })
    //         } else {
    //             this.loading = false;
    //         }
    //     })
    // },
    /**
     * 获取支付记录
     */
    async getPayRecord() {
      this.loading = true;
      let { code, data } = await getPayRecord({ orderNumber: this.dialogObj.orderCombinedNum });
      if (code == 200 && !isEmptyArray(data)) {
        this.payObj = data.find(item => { return item.paySuccess == '1' })
        this.payObj.payWaystr = dictText(this.payObj.payWay, this.PAY_WAY)
        let { orderNumber, orderPayNumber, payPalNumber, payWay } = this.payObj
        this.refundForm.orderNumber = orderNumber
        this.refundForm.orderPayNumber = orderPayNumber
        this.refundForm.payPalNumber = payPalNumber
        this.refundForm.refundWay = payWay
        this.loading = false;
        // this.createRefundTask()
      } else {
        this.loading = false;
      }
    },


  },
}
</script>
<style lang="less" scoped>
.content {
  .content-price {
    color: #FE8F1F;
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 24px;

    .price-icon {
      font-size: 16px;
      margin-right: 4px;
    }
  }
}
</style>